<div>

  <p-tabs [(value)]="index" (onChange)="handleChange($event)">
    <p-tablist>
      @if (canViewWellness) {<p-tab [value]="0">Tree Wellness</p-tab>}
      @if (canViewWork) {<p-tab [value]="1">Tree Work</p-tab>}
      <div style="width: 100%;">
        <ng-select class="custom" required [items]="views" id="viewDropdown" name="views" bindLabel="label" appendTo="body"
          bindValue="value" [selectOnTab]="true" [searchable]="false" [clearable]="false" [(ngModel)]="selectedView">
          <ng-template ng-label-tmp let-item="item">
            {{item.label}}
          </ng-template>
        </ng-select>        
      </div>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel [value]="0">
        @if (selectedView == '2day' && index == 0) {
        <div>
          <app-wellness-day-view></app-wellness-day-view>
        </div>
        }
        @if (selectedView == 'week' && index == 0) {
        <div>
          <app-wellness-week-view></app-wellness-week-view>
        </div>
        }
      </p-tabpanel>

      @if (canViewWork) {
      <p-tabpanel [value]="1">
        @if (selectedView == '2day' && index == 1) {
        <div>
          <app-work-day-view></app-work-day-view>
        </div>
        }
        @if (selectedView == 'week' && index == 1) {
        <div>
          <app-work-week-view></app-work-week-view>
        </div>
        }
      </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
</div>